const convertPValueToString = (PValue) => (PValue === null ? '' : PValue.toString());
export default convertPValueToString;
